import { CubeTextureLoader, TextureLoader } from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

class Loaders {
    gltfLoader: GLTFLoader;
    textureLoader: TextureLoader;
    textureCubeLoader: CubeTextureLoader;
    dracoLoader: DRACOLoader;

    constructor() {
        this.gltfLoader = new GLTFLoader();
        this.textureLoader = new TextureLoader();
        this.textureCubeLoader = new CubeTextureLoader();
        this.dracoLoader = new DRACOLoader();
        this.textureLoader.setCrossOrigin('anonymous');
    }

    disposeDracoLoader() {
        this.dracoLoader.dispose();
    }
}

export default new Loaders();
